// src/locales/en/users.js
export const users = {
    
    manageTeamMembers: "ඔබේ කණ්ඩායම් සාමාජිකයින් සහ ඔවුන්ගේ ප්‍රවේශය කළමනාකරණය කරන්න",
    loadingUsers: "පරිශීලකයින් පූරණය වෙමින්...",
    loadingUsersDesc: "අපි පරිශීලක දත්ත ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    unableToLoadUsers: "පරිශීලකයින් පූරණය කළ නොහැක",
    searchUsersPlaceholder: "නම, ඊමේල් අනුව පරිශීලකයින් සොයන්න...",
    allStatus: "සියලුම තත්ත්වයන්",
    allRoles: "සියලුම භූමිකාවන්",
    role: "භූමිකාව",
    show: "පෙන්වන්න",
    perPage: "පිටුවකට",
    noUsersFound: "පරිශීලකයින් හමු නොවිණි",
    noUsersFoundDesc: "ඔබේ වර්තමාන සෙවුම් සහ ෆිල්ටර නිර්ණායක සමඟ ගැලපෙන පරිශීලකයින් නොමැත.",
    noUsersYet: "තවම පරිශීලකයින් නැත",
    noUsersYetDesc: "ඔබේ පළමු පරිශීලකයා එකතු කිරීමෙන් ඔබේ කණ්ඩායම ගොඩනැගීම ආරම්භ කරන්න.",
    addFirstUser: "පළමු පරිශීලකයා එකතු කරන්න",
    user: "පරිශීලකයා",
    assignments: "පැවරීම්",
    userAvatarAlt: "{{name}} ගේ අවතාරය",
    noRoleAssigned: "භූමිකාවක් පවරා නැත",
    shopCount: "වෙළඳසැල් {{count}} ක්",
    warehouseCount: "ගබඩා {{count}} ක්",
    noAssignments: "පැවරීම් නැත",
    viewDetails: "විස්තර බලන්න",
    editUser: "පරිශීලකයා සංස්කරණය කරන්න",
    activate: "සක්‍රීය කරන්න",
    deactivate: "අක්‍රීය කරන්න",
    confirmStatusChange: "ඔබට \"{{userName}}\" පරිශීලකයා {{action}} කිරීමට අවශ්‍යද?",
    statusUpdateSuccess: "\"{{userName}}\" පරිශීලකයා සාර්ථකව {{status}} කර ඇත.",
    statusUpdateFailed: "පරිශීලක තත්ත්වය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    confirmDelete: "ඔබට \"{{userName}}\" පරිශීලකයා මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    deleteUser: "පරිශීලකයා මකන්න",
    deleteSuccess: "\"{{userName}}\" පරිශීලකයා සාර්ථකව මකා දමන ලදී.",
    deleteFailed: "පරිශීලකයා මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    showingRecords: "පරිශීලකයින් {{total}} න් {{start}}-{{end}} පෙන්වමින්",
    firstPage: "පළමු පිටුව",
    previousPage: "පෙර පිටුව",
    nextPage: "ඊළඟ පිටුව",
    lastPage: "අවසාන පිටුව",

    createNewUser: "නව පරිශීලකයෙකු සාදන්න",
    addNewTeamMember: "ඔබේ ව්‍යාපාරයට නව කණ්ඩායම් සාමාජිකයෙකු එකතු කරන්න",
    backToUsers: "පරිශීලකයින් වෙත ආපසු",
    
    basicInformation: "මූලික තොරතුරු",
    basicInformationDesc: "පරිශීලකයා පිළිබඳ මූලික විස්තර සපයන්න",
    profilePicture: "පැතිකඩ පින්තූරය",
    profilePictureDesc: "පැතිකඩ පින්තූරයක් උඩුගත කරන්න (විකල්ප)",
    accountSettings: "ගිණුම් සැකසුම්",
    accountSettingsDesc: "පරිශීලක භූමිකාව සහ පිවිසුම් අක්තපත්‍ර වින්‍යාස කරන්න",
    shopAssignment: "වෙළඳසැල් පැවරීම",
    shopAssignmentDesc: "නිශ්චිත වෙළඳසැල් වලට පරිශීලකයා පවරන්න (විකල්ප)",
    warehouseAssignment: "ගබඩා පැවරීම",
    warehouseAssignmentDesc: "නිශ්චිත ගබඩා වලට පරිශීලකයා පවරන්න (විකල්ප)",
    
    fullName: "සම්පූර්ණ නම",
    fullNamePlaceholder: "සම්පූර්ණ නම ඇතුළත් කරන්න",
    emailAddress: "ඊමේල් ලිපිනය",
    emailPlaceholder: "ඊමේල් ලිපිනය ඇතුළත් කරන්න",
    phoneNumber: "දුරකථන අංකය",
    phonePlaceholder: "දුරකථන අංකය ඇතුළත් කරන්න",
    employeeNumber: "සේවක අංකය",
    employeeNumberPlaceholder: "සේවක අංකය ඇතුළත් කරන්න",
    address: "ලිපිනය",
    addressPlaceholder: "ලිපිනය ඇතුළත් කරන්න",
    birthday: "උපන්දිනය",
    userRole: "පරිශීලක භූමිකාව",
    selectRole: "භූමිකාවක් තෝරන්න",
    password: "මුරපදය",
    passwordPlaceholder: "මුරපදය ඇතුළත් කරන්න",
    confirmPassword: "මුරපදය තහවුරු කරන්න",
    confirmPasswordPlaceholder: "මුරපදය තහවුරු කරන්න",
    accountIsActive: "ගිණුම සක්‍රීයයි",
    defaultShop: "පෙරනිමි වෙළඳසැල",
    selectDefaultShop: "පෙරනිමි වෙළඳසැල තෝරන්න",
    defaultWarehouse: "පෙරනිමි ගබඩාව",
    selectDefaultWarehouse: "පෙරනිමි ගබඩාව තෝරන්න",
    
    clickToUpload: "පැතිකඩ පින්තූරය උඩුගත කිරීමට ක්ලික් කරන්න",
    profilePictureFormats: "PNG, JPG, WEBP 5MB දක්වා",
    
    nameRequired: "නම අවශ්‍යය",
    emailRequired: "ඊමේල් අවශ්‍යය",
    invalidEmail: "කරුණාකර වලංගු ඊමේල් ලිපිනයක් ඇතුළත් කරන්න",
    emailTaken: "මෙම ඊමේල් ලිපිනය දැනටමත් ගෙන ඇත",
    emailAvailable: "ඊමේල් ලබා ගත හැකිය",
    roleRequired: "කරුණාකර පරිශීලක භූමිකාවක් තෝරන්න",
    passwordRequired: "මුරපදය අවශ්‍යය",
    passwordMinLength: "මුරපදය අවම වශයෙන් අක්ෂර 6ක් විය යුතුය",
    confirmPasswordRequired: "කරුණාකර ඔබේ මුරපදය තහවුරු කරන්න",
    passwordsDoNotMatch: "මුරපද නොගැලපේ",
    invalidPhone: "කරුණාකර වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න",
    defaultShopRequired: "වෙළඳසැල් පවරා ඇති විට කරුණාකර පෙරනිමි වෙළඳසැලක් තෝරන්න",
    defaultWarehouseRequired: "ගබඩා පවරා ඇති විට කරුණාකර පෙරනිමි ගබඩාවක් තෝරන්න",
    invalidProfilePictureFormat: "පැතිකඩ පින්තූරය PNG, JPG, JPEG, හෝ WEBP ආකෘතියේ විය යුතුය",
    profilePictureTooLarge: "පැතිකඩ පින්තූර ගොනු ප්‍රමාණය 5MB ට වඩා අඩු විය යුතුය",
    
    loadingData: "දත්ත පූරණය වෙමින්...",
    loadingDataDesc: "අපි අවශ්‍ය තොරතුරු ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    
    createUser: "පරිශීලකයා සාදන්න",
    
    userCreatedSuccess: "පරිශීලකයා \"{{userName}}\" සාර්ථකව සාදන ලදී!",
    failedToCreateUser: "පරිශීලකයා සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToLoadData: "අවශ්‍ය දත්ත පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",

    editUser: "පරිශීලකයා සංස්කරණය කරන්න",
    updateUser: "පරිශීලකයා යාවත්කාලීන කරන්න",
    updateTeamMember: "කණ්ඩායම් සාමාජිකයේ විස්තර සහ අවසර යාවත්කාලීන කරන්න",
    changePassword: "මුරපදය වෙනස් කරන්න",
    loadingUser: "පරිශීලකයා පූරණය වෙමින්...",
    loadingUserDesc: "අපි පරිශීලක දත්ත ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    userNotFound: "පරිශීලකයා හමු නොවිණි. එය මකා දැමී ඇති විය හැක.",
    failedToLoadUser: "පරිශීලක දත්ත පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    noChangesToSave: "සුරැකීමට වෙනස්කම් කර නැත.",
    userUpdatedSuccess: "පරිශීලකයා '{{userName}}' සාර්ථකව යාවත්කාලීන කරන ලදී!",
    failedToUpdate: "පරිශීලකයා යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    confirmDiscardChanges: "ඔබට නොසුරකින ලද වෙනස්කම් තිබේ. සුරකින්නේ නැතිව පිටවීමට ඔබට අවශ්‍යද?",
    discardChanges: "වෙනස්කම් ඉවත දමන්න",
    noChanges: "වෙනස්කම් නැත",
    unsavedChanges: "නොසුරකින ලද වෙනස්කම්",
}